module.exports = __webpack_public_path__ + "static/media/Villas.7b883b2e.png";